import { MatchingRequest, MemberDetailedInfo, User } from "@/types";

import { axios } from "../axios.instance";

export type GetUsersRequest = MatchingRequest & {
  perPage?: number;
  cursor?: string;
};

export type GetUsersResponse = {
  data: Array<Pick<User, "id" | "role"> & MemberDetailedInfo>;
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getUsers = async (params: GetUsersRequest): Promise<GetUsersResponse> => {
  const { data } = await axios.get(`users${params.location ? "?location=" + params.location.join(",") : ""}`, {
    params: { ...params, location: undefined },
  });

  return data;
};
